import request from '@/utils/request'
/**
 * 当前登录账号的封禁状态，未封禁时 data 为 null。
 *
 * 封禁期间账号照常登录（只限制发帖、评论、私信等操作），所以这是登录态接口。
 * 用于登录后的一次性提醒、系统通知「查看详情」打开封禁详情、申诉后刷新申诉状态。
 */
export function getBanStatus () {
  return request({
    url: '/v1/account/ban/status',
    method: 'get',
    // 后台静默检查，网络抖动不弹统一的网络错误提示
    skipNetworkErrorToast: true
  })
}
/**
 * 提交封禁申诉。
 *
 * 登录状态下服务端只认登录账号，userId 可以不传；只有旧版服务端封禁后清掉了登录态时，
 * 才需要传封禁详情里的 userId。服务端会校验账号确实处于封禁中，并按账号 + IP 维度限流。
 *
 * @param {Object} data { userId?, content, contact, images }
 */
export function submitBanAppeal (data) {
  return request({
    url: '/v1/account/ban/appeal',
    method: 'post',
    data
  })
}
/**
 * 封禁原因字典（申诉页展示违规类型说明用）
 */
export function getBanReasons () {
  return request({
    url: '/v1/account/ban/reasons',
    method: 'get',
    skipTokenRefresh: true
  })
}
